import Vue from 'vue'
import Router from 'vue-router'
import homepage from '@/views/homepage'
import detail from '@/views/detail'
import checktoken from '@/views/checktoken'
import Signin from '@/views/Signin'
import Signup from '@/views/Signup'
import testpromise from '@/views/testpromise'
import ForgotPassword from '@/views/ForgotPassword'
import SigninMentor from '@/components/SigninMentor'
import SigninIntegreat from '@/components/SigninIntegreat'
import ReviewComment from '@/views/ReviewComment'
import store from './store';
Vue.use(Router)

const ifAuthenticatedAll = (to, from, next) => {
  if (typeof store.state.user.email === 'undefined' || store.state.user.email === null || store.state.user.email === '') {
    next('/signin')
  }else if (store.state.user.email) {
    next()
  }else{
    next('/signin')
  }
};

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/testpromise/:id',
      name: 'testpromise',
      component: testpromise,
    },
    {
      path: '/',
      name: 'homepage',
      component: homepage,
      beforeEnter:ifAuthenticatedAll
    },
    {
      path: '/detail/:id',
      name: 'detail',
      component: detail,
      beforeEnter:ifAuthenticatedAll
    },
    {
      path: '/token/:tokenticket',
      name: 'checktoken',
      component: checktoken
    },
    {
      path: '/signin',
      name: 'signin',
      component: Signin
    },
    {
      path: '/signup',
      name: 'signup',
      component: Signup
    },
    {
      path: '/forgot-password',
      name: 'forgotPassword',
      component: ForgotPassword
    },
    {
      path: '/signin-mentor',
      component: SigninMentor
    },
    {
      path: '/signin-integreat',
      component: SigninIntegreat
    },
    {
      path: '/review-comment',
      component: ReviewComment
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router.js